module.exports = __webpack_public_path__ + "img/gld_gbt825_1988.prt.68ce4af0.jpg";